// eslint-disable-next-line import/prefer-default-export
export const isMobile = () =>
	/Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
